import React from 'react';
import { MIcon } from '../Icon';
import { useStyletron } from 'baseui';
import { languageProvider } from './i18n';
import { FileUpload } from 'primereact/fileupload';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { IDummyProps } from './types';
import * as meta from '../../meta-data.json';

const EmptyTemplate = ({ dragDropLabel, auto }: any) => {
	const [useCss] = useStyletron();
	return (
		<div className={'p-m-0 ' + useCss({ display: 'flex', alignItems: 'center' })}>
			<MIcon icon={auto ? 'file_upload' : 'add'} color="rgb(159, 164, 170)" size="var(--epods--icon-small)" />
			<span className={useCss({ textOverflow: 'ellipsis' })}>{dragDropLabel}</span>
		</div>
	);
};

export const View = (props: IDummyProps) => {
	const { rootref, testId = 'epo-upload', ...rest } = props;
	const cssVersion = `epo-upload-${meta.version}`;
	const [useCss] = useStyletron();

	const uploadOptions = {
		label: props.uploadLabel || languageProvider.en.uploadLabel,
		icon: <MIcon icon={props.auto ? 'file_upload' : 'add'} size="small" />,
		className: 'pi-upload-button',
	};

	const cancelOptions = {
		label: props.cancelLabel || languageProvider.en.cancelLabel,
		icon: <MIcon icon="delete_sweep" color="var(--epods--color-text-button-secondary)" size="small" />,
		className: `pi-delete-button ${useCss({ marginLeft: 'auto !important' })}`,
	};

	const getChooseLabel = () => {
		if (props.chooseLabel) {
			return props.chooseLabel;
		}

		return props.mode === 'basic'
			? languageProvider.en.chooseLabel
			: props.auto ? languageProvider.en.chooseManyLabelAuto : languageProvider.en.chooseManyLabel
	}

	return (
		<div
			data-testid={testId}
			data-epo={cssVersion}
			{...{ part: cssVersion, mode: props.mode }}
			className={cssVersion + ' ' + props.mode}
		>
			<FileUpload
				ref={rootref}
				{...rest}
				chooseLabel={getChooseLabel()}
				uploadOptions={props.uploadOptions ? { ...uploadOptions, ...props.uploadOptions } : uploadOptions}
				cancelOptions={props.cancelOptions ? { ...cancelOptions, ...props.cancelOptions } : cancelOptions}
				emptyTemplate={() => (
					<EmptyTemplate dragDropLabel={props.dragDropLabel || props.auto ? languageProvider.en.dragdropAreaAuto : languageProvider.en.dragdropArea} auto={props.auto} />
				)}
				//multiple={props.multiple || true}
				mode={props.mode || 'advanced'}
				auto={props.auto || false}
				// onSelect={(e: any) => console.log('files selected')} // NOT WORKING :: PRIME BUG
				{...getBaseCustomProps(props)}
			/>
		</div>
	);
};
